import { render, staticRenderFns } from "./cronLogs.vue?vue&type=template&id=8963b992&scoped=true"
import script from "./cronLogs.vue?vue&type=script&lang=js"
export * from "./cronLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8963b992",
  null
  
)

export default component.exports